import React from 'react';
import ModalDialog, { type ModalDialogProps } from '@atlaskit/modal-dialog';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';

export {
	ModalHeader,
	ModalTitle,
	ModalBody,
	ModalFooter,
	ModalTransition,
	// eslint-disable-next-line jira/export/no-external-exports
} from '@atlaskit/modal-dialog';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: ModalDialogProps) => (
	<ShortcutScope>
		<ModalDialog {...props} />
	</ShortcutScope>
);
